import "./bootstrap.min.css";
import "./style.css";
import "./responsive.css";
import "./custom.css";
import Select from "react-select";
import Flag from "react-world-flags";
import Announcement from "./Announcement";
import { useContext } from "react";
import PortalContext from "../Pages/PortalContext";
import { TranslationContext } from "../Pages/TranslationContext";
import { useGetTranslation } from "../Components/Translate";
import { useGetRequest } from "../Client/index.js";
import acceptLanguage from "accept-language";
import { useState, useEffect, useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";

const LS_KEY = "portalLanguageCode";

export default function Header(props) {
  const { portal } = useContext(PortalContext);
  const getTranslation = useGetTranslation();
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get("embed") === "1";

  acceptLanguage.languages(["en-US", "zh-CN"]);
  acceptLanguage.get(navigator.language);

  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const { data, setLanguageCode } = useContext(TranslationContext);

  const { status: statusLanguages, data: dataLanguages } = useGetRequest(
    "api/v2-label-portal-languages.php",
    {}
  );

  // Guard for initial undefined
  const options = (dataLanguages || []).map((country) => ({
    value: country.language,
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Flag
          code={country.flag}
          style={{ width: 20, height: 15, marginRight: 10 }}
        />
        {country.name}
      </div>
    ),
  }));

  useEffect(() => {
    if (!dataLanguages || dataLanguages.length === 0) return;

    // 1) Try saved language first
    const savedCode = localStorage.getItem(LS_KEY)?.toUpperCase();

    // 2) Otherwise use accept-language
    const userLangCode = acceptLanguage
      .get(navigator.language)
      ?.split("-")[0]
      .toUpperCase();

    let selectedLang =
      (savedCode &&
        dataLanguages.find(
          (lang) => lang.language.toUpperCase() === savedCode
        )) ||
      dataLanguages.find(
        (lang) => lang.language.toUpperCase() === userLangCode
      );

    // 3) Fallback to your existing default
    if (!selectedLang) {
      selectedLang = {
        language: "ES",
        name: "Spanish",
        flag: "es",
      };
    }

    // If the portal state says user picked one before, honor that unless localStorage says otherwise
    const usePortalChoice =
      portal.userChangedLanguage &&
      !savedCode; /* localStorage wins if present */

    const chosenLanguageCode = usePortalChoice
      ? portal.language
      : selectedLang.language;

    const chosenLangObj =
      dataLanguages.find(
        (l) => l.language.toUpperCase() === chosenLanguageCode.toUpperCase()
      ) || selectedLang;

    const selectedOption = {
      value: chosenLangObj.language,
      label: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Flag
            code={chosenLangObj.flag}
            style={{ width: 20, height: 15, marginRight: 10 }}
          />
          {chosenLangObj.name}
        </div>
      ),
    };

    setSelectedLanguage(selectedOption);
    setLanguageCode(chosenLangObj.language);

    // Keep portal in sync (same as your current approach)
    portal.userChangedLanguage = true;
    portal.language = chosenLangObj.language;
    portal.languageName = chosenLangObj.name;

    // Also persist to localStorage so a refresh keeps it
    localStorage.setItem(LS_KEY, chosenLangObj.language);
  }, [dataLanguages]);

  const isDemo =
    portal?.data?.isDemo === true

  return (
    <>
      {isDemo && (
        <Announcement
          color={"#c2410c"}
          message={getTranslation(
            "DEMO_BANNER",
            "Do not use for returns. This is for demo purposes only. Your return may not be processed if using this portal"
          )}
        />
      )}

      {portal?.data?.settings?.announcement && (
        <Announcement
          color={"#eb4034"}
          message={portal?.data?.settings?.announcement}
        />
      )}

      <section class="mt-2">
        <nav class="navbar navbar-expand-lg ">
          <div class="container">
            {/* <a href="/" class="navbar-brand text-dark">
              {portal?.data?.settings?.logoUrl && (
                <img
                  src={portal?.data?.settings?.logoUrl}
                  class="w-60 img-fluid mb-3 retailer-logo"
                  alt="Retailer Logo"
                />
              )}
            </a> */}
            {!isEmbed && (
              <Link to="/" className="navbar-brand text-dark">
                {portal?.data?.settings?.logoUrl && (
                  <img
                    src={portal.data.settings.logoUrl}
                    className="w-60 img-fluid mb-3 retailer-logo"
                    alt="Retailer Logo"
                  />
                )}
              </Link>
            )}
            {!isEmbed && (
            <div class="container-of-navigation">
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarResponsive"
                aria-controls="navbarResponsive"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="fa fa-bars"></span>
              </button>
              <div
                class="collapse navbar-collapse"
                style={{ marginRight: "150px" }}
                id="navbarResponsive"
              >
               

                <ul className="navbar-nav text-navbar">
                  <li>
                    <Link to="/">{getTranslation("HEADER_HOME", "Home")}</Link>
                  </li>
                  <li>
                    <Link to="/help">
                      {getTranslation("HEADER_HELP", "Help").slice(0, 25)}
                    </Link>
                  </li>
                  <li>
                    <Link to="/tracking">
                      {getTranslation("HEADER_TRACKING", "Tracking").slice(
                        0,
                        30
                      )}
                    </Link>
                  </li>
                  <li>
                    <a
                      href={portal?.data?.settings?.retailerUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {getTranslation("HEADER_VISIT", "Visit {tradingName}", {
                        tradingName: portal?.data?.settings?.tradingName,
                      }).slice(0, 30)}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            )}

            <div
              class="language-small"
              style={{
                width: "170px",
                flexShrink: 0,
                ...(isEmbed && { marginLeft: "auto" }),
              }}
            >
              <Select
                options={options}
                value={selectedLanguage}
                onChange={(selectedOption) => {
                  setSelectedLanguage(selectedOption);
                  setLanguageCode(selectedOption.value);

                  // Keep your existing portal mutations
                  portal.userChangedLanguage = true;
                  portal.language = selectedOption.value;
                  portal.languageName = selectedOption.label.props.children[1];

                  // Persist to localStorage (NEW)
                  localStorage.setItem(LS_KEY, selectedOption.value);
                }}
                isSearchable={true}
              />
            </div>
          </div>
        </nav>
      </section>
    </>
  );
}
